import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faArrowUp, faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { Trans } from "@lingui/react/macro";

const ProjectItem = ({ project, index, isLastItem, translatedDescription, timing, showPopup, handleNavigateToProject, handleChangeOrder}) => {
    return (
        <div key={project.project_id} className="projectRow">
            <div className="projectNumberContainer">
            <div className="orderArrows">
                    <button 
                        className="arrowUpButton" 
                        onClick={() => handleChangeOrder(true, index)}
                        disabled={index === 0}
                    >
                        <FontAwesomeIcon icon={faArrowUp} />
                    </button>
                    <span className="projectNumber">{index + 1}</span>
                    <button 
                        className="arrowDownButton" 
                        onClick={() => handleChangeOrder(false, index)}
                        disabled={isLastItem}
                    >
                        <FontAwesomeIcon icon={faArrowDown} />
                    </button>
                </div>
                <button
                    className="arrowButton"
                    onClick={() => handleNavigateToProject(project.project_id)}
                >
                    <FontAwesomeIcon icon={faArrowRight} size="2x" />
                </button>
            </div>
            <div className="projectContent">
                <div className="projectTextAndActions">
                    <div className="projectText">
                        <h3 className="projectTitle">{project.customer_name}</h3>
                        {/* 30/10/2026 (Bartel): verzekeringsdossier waarvan het mandaat nog getekend moet worden. */}
                        {project.mandaat_te_tekenen ? (
                            <p className="mandateBadge">✍ <Trans>Sign mandate</Trans></p>
                        ) : null}
                        <p className="projectDescription">
                            <Trans>Description:</Trans> {translatedDescription || project.description}
                        </p>
                        <p className="projectDescription">
                            <Trans>Address:</Trans> {project.street} {project.house_number}, {project.postal_number} {project.town}
                        </p>
                    </div>
                    <div className="actionButtons">
                        {timing && timing.start_time ? (
                            <button className="startButton disabled" disabled>
                                <Trans>Start:</Trans> {timing.start_time}
                            </button>
                        ) : (
                            <button
                                className="startButton"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    showPopup("start_time", project);
                                }}
                            >
                                <Trans>Start Work</Trans>
                            </button>
                        )}

                        {timing && timing.start_time ? (
                            timing.end_time ? (
                                <button className="endButton disabled" disabled>
                                    <Trans>End:</Trans> {timing.end_time}
                                </button>
                            ) : (
                                <button
                                    className="endButton"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        showPopup("end_time", project);
                                    }}
                                >
                                    <Trans>End Work</Trans>
                                </button>
                            )
                        ) : (
                            <button className="endButton disabled" disabled>
                                <Trans>End Work</Trans>
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectItem;
